<template>
  <!-- <jt-card-default
    :shouldShowSelectMonth ="true"
    :cardSelectType="0"
    @change="onChangeSelectDoughnut"
  >
    <div v-if="isLoadingDoughnut" class="div-loader">
      <div class="spinning-loader rotate"></div>
    </div>-->
    <jt-doughnut-chart
      centralTitleConst="DASHBOARD_CONSUMER_UNIT_TYPE"
      :data="doughnutData"
      :shouldShowLegend="true"
      :shouldShowLabelParts="false"
      :shouldShowValueInLabelParts="false"
      :shouldShowPercentageInLabelParts="true"
    />
  <!-- </jt-card-default> -->
</template>
<script>
import JtDoughnutChart from 'src/components/charts/JtDoughnutChart.vue'
import JtCardDefault from 'src/components/dashboard/dashboard-card-components/base/JtCardDefault.vue'
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'

@Component({
  name: 'ConsumerUnitType',
  components: {
    JtCardDefault,
    JtDoughnutChart
  }
})
export default class ConsumerUnitType extends Vue {
  isLoadingDoughnut = false;

  doughnutData = [];
  currentDate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1
  };

  async created () {
    await this.onChangeSelectDoughnut(this.currentDate)
  }

  async getDoughnutData (date) {
    const { registros } = await repository.resolveDatatableModel(
      'consumerUnit.hql',
      {
        grid: 'consumerUnitTypeSum',
        month: date.month,
        year: date.year
      }
    )

    return registros
  }

  async onChangeSelectDoughnut (newValue) {
    this.isLoadingDoughnut = true
    this.doughnutData = await this.getDoughnutData(newValue)

    setTimeout(() => {
      this.isLoadingDoughnut = false
    }, 500)
  }
}
</script>

<style lang='stylus' scoped>
@import '~quasar-variables';
</style>
